module.exports = __webpack_public_path__ + "static/media/04-chs.78c36384.png";